/** Figma “Video Placeholder” (Videos in Product Data, node 225:19726). */
export const PRODUCT_VIDEO_PLACEHOLDER_CAMERA_SRC = '/assets/img/product-lightbox/video-placeholder-camera.svg';

export const PRODUCT_VIDEO_PLACEHOLDER_BACKGROUND = '#f3f2f6';

export interface ProductVideoThumbnailSource {
    thumbnailSignedUrl?: string;
}

export function getProductVideoThumbnailUrl(video: ProductVideoThumbnailSource | undefined): string | undefined {
    const url = video?.thumbnailSignedUrl?.trim();
    return url ? url : undefined;
}

export function usesProductVideoPlaceholder(video: ProductVideoThumbnailSource | undefined): boolean {
    return !getProductVideoThumbnailUrl(video);
}

export interface DownloadListVideoThumbSource {
    type?: string;
    thumbnailSignedUrl?: string;
    hasPreview?: boolean;
    thumbnailFilename?: string;
}

/** Download list row: real thumb when wired; otherwise Figma placeholder for video items. */
export interface ProductVideoWithSignedUrl {
    signedUrl?: string;
    videoId: string;
    filename?: string;
    thumbnailSignedUrl?: string;
}

/** Same rule as the lightbox: only videos the backend marked as deliverable. */
export function getDeliverableProductVideos<T extends ProductVideoWithSignedUrl>(videos: T[] | undefined): T[] {
    if (!videos?.length) {
        return [];
    }
    return videos.filter((video) => Boolean(video?.signedUrl?.trim()));
}

export function downloadListItemUsesVideoPlaceholder(item: DownloadListVideoThumbSource): boolean {
    if (item.type !== 'video') {
        return false;
    }
    if (getProductVideoThumbnailUrl(item)) {
        return false;
    }
    if (item.hasPreview && item.thumbnailFilename) {
        return false;
    }
    return true;
}
